import axios from 'axios';
import config from '@/config/env-constants';

export default {

    getCompanies(filterBy, view, currUserId, pagination = {}) {
        const url = `${config.cloudFunctionsBaseUrl}/getCompanies`;
        return axios.post(url, {
            view: view,
            currUserId: currUserId,
            filterBy: JSON.stringify(filterBy),
            search: pagination.search,
            page: pagination.page,
            pageSize: pagination.pageSize,
        });
    },

    paginateCompanies(param) {
        const url = `${config.cloudFunctionsBaseUrl}/paginateCompanies`;
        return axios.post(url, {
            currUserId: param.currUserId,
            view: param.view,
            filterBy: JSON.stringify(param.filterBy),
            page: param.page,
            limit: param.limit,
            startAt: param.startAt,
            direction: param.direction
        });
    },

    saveCompany(company, currUserId, currTimeStamp) {
        const url = `${config.cloudFunctionsBaseUrl}/saveCompany`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            company: JSON.stringify(company)
        });
    },

    saveCompanyAndStorageLocation(company, storageLocation, currUserId, currTimeStamp) {
        const url = `${config.cloudFunctionsBaseUrl}/saveCompany`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            company: JSON.stringify(company),
            storageLocation: JSON.stringify(storageLocation),
        });
    },

    updateCompanyLogo(logoDetails, currUserId, currTimeStamp) {
        const url = `${config.cloudFunctionsBaseUrl}/updateCompanyLogo`;
        return axios.post(url, {
            currUserId: currUserId,
            currTimeStamp: currTimeStamp,
            logoDetails: JSON.stringify(logoDetails)
        });
    },

    getRegions(currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/getRegions`;
        return axios.post(url, {
            currUserId: currUserId
        });
    },

    getAreas(currUserId) {
        const url = `${config.cloudFunctionsBaseUrl}/getAreas`;
        return axios.post(url, {
            currUserId: currUserId
        });
    },

}